module.exports = __webpack_public_path__ + "img/maf.5b9ff36c.svg";